export function generateInitials(first_name, last_name, email) {
  let initials = '';

  // Check if name and surname are provided
  if (first_name && last_name) {
    initials = `${first_name[0]}${last_name[0]}`;
  } else if (first_name) {
    // Only name is provided
    initials = first_name[0];
  } else if (last_name) {
    // Only surname is provided
    initials = last_name[0];
  } else if (email) {
    // Fallback to email if name and surname are not available
    initials = email.substring(0, 2);
  } else {
    // In case email is also not provided or is empty
    initials = '?';
  }

  return initials.toUpperCase();
}